import { render } from "./session-counter.vue?vue&type=template&id=5d5e21dd&scoped=true&ts=true"
import script from "./session-counter.vue?vue&type=script&lang=ts"
export * from "./session-counter.vue?vue&type=script&lang=ts"

import "./session-counter.vue?vue&type=style&index=0&id=5d5e21dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5e21dd"]])

export default __exports__